<template>
  <AuthLayout show-brand>
    <LoginForm @login-success="onLoginSuccess" />

    <template #footer>
      ¿Problemas para ingresar?
      <RouterLink to="/forgot-password">Recupera tu acceso</RouterLink>
    </template>
  </AuthLayout>
</template>

<script setup>
import { useRouter } from 'vue-router';
import AuthLayout from '../components/layout/AuthLayout.vue';
import LoginForm from '../components/auth/LoginForm.vue';

const router = useRouter();

const onLoginSuccess = () => {
  router.push('/');
};
</script>
